var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05469 10.5001C3.05469 12.5721 3.87779 14.5592 5.34292 16.0243C6.80804 17.4895 8.79518 18.3126 10.8672 18.3126C12.9392 18.3126 14.9263 17.4895 16.3915 16.0243C17.8566 14.5592 18.6797 12.5721 18.6797 10.5001C18.6797 8.42806 17.8566 6.44092 16.3915 4.97579C14.9263 3.51066 12.9392 2.68756 10.8672 2.68756C8.79518 2.68756 6.80804 3.51066 5.34292 4.97579C3.87779 6.44092 3.05469 8.42806 3.05469 10.5001Z",
    stroke: "#313131",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8672 7.37506V10.5001L12.8203 12.4532",
    stroke: "#313131",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.686a67c44d07ace42562a0f8f45f9e03.svg";
export { ForwardRef as ReactComponent };